import React from 'react';

import AbsoluteDropdownContainer, {
  AbsoluteDropdownContainerProps,
} from 'ui-library/AbsoluteDropdownContainer';

export default function MockAbsoluteDropdownContainer(props: AbsoluteDropdownContainerProps): JSX.Element {
  return (
    <div style={{position: 'absolute'}}>
      {props.children}
      <div
        onClick={(e) => {
          if (props.shouldCloseOnInsideClick) {
            props.onRequestClose();
          }
        }}
      >
        {props.open ? props.menu : null}
      </div>
    </div>
  );
}

Object.assign(MockAbsoluteDropdownContainer, {
  propTypes: AbsoluteDropdownContainer.propTypes,
  defaultProps: AbsoluteDropdownContainer.defaultProps,
});
